import { ProductEditor } from './ProductEditor.js';
import { ComponentType } from './InteriorInteraction.js';

class VariantProductEditor extends ProductEditor {
  constructor(config, designerService, productService) {
    super(config, designerService, productService);
    this.componentType = ComponentType;

    this.addDropdownListEventHandlers(this.elements.variants, async (changedElement, changedValue) => {
      try {
        // Note, changedValue is the Guid key of the variant node
        //this.propertyChanged('variantId', changedValue, this.elements.variant, this.elements.variant);
        const variantId = await this.getProductVariantId(changedElement, changedValue);
        if (!variantId || variantId.length !== 36 || !/[0-9a-fA-F]/.test(variantId[0])) {
          throw new Error('Unable to look up the product variant given the input product attributes.');
        }
        this.propertyChanged('variantId', variantId, changedElement, changedElement);
      } catch (ex) {
        this.toggleErrorMessage(true, this.config.genericErrorMessage); //'Sorry! Something unexpected happened in the app.'
        throw ex;
      }
    });

  }

  async getProductVariantId(changedElement, changedAttrValue) {
    return null;
  }

  assignEditFieldElements(elementIds) {
    super.assignEditFieldElements(elementIds);
    //this.elements.variant = document.getElementById(elementIds.variant);
    this.elements.variants = document.querySelectorAll('button[data-comp-type="variant"]');
  }

  getSelectedValueFromProduct(product, buttonElement) {
    return null;
  }

  doDisplayProduct(product, validators, changedElement, changeLog) {
    super.doDisplayProduct(product, validators, changedElement, changeLog);

    let validator = validators ? validators.variant : null;
    //this.displayDropdownList(this.elements.variant, product.variantId, changeLog, 'Variant',
    for (const buttonElement of this.elements.variants) {
      const selectedValue = this.getSelectedValueFromProduct(product, buttonElement);
      this.displayDropdownList(buttonElement, selectedValue, changeLog, 'Variant',
        changedElement, this.config.variantDValues);
    }
  }
}

export class SingleVariantProductEditor extends VariantProductEditor {
  async getProductVariantId(changedElement, changedAttrValue) {
    return changedAttrValue;
  }

  getSelectedValueFromProduct(product, buttonElement) {
    return product.variantId;
  }
}

export class MultiVariantProductEditor extends VariantProductEditor {

  extractAlias(buttonElement) {
    return buttonElement.id.replace('DropDown-', '');
  }

  getSelectedValue(buttonElement) {
    const menu = buttonElement.parentElement.querySelector('.dropdown-menu');
    const activeItem = menu.querySelector('.dropdown-item.active');
    return activeItem ? activeItem.name : null;
  }

  getSelectedValueFromProduct(product, buttonElement) {
    const attrAlias = this.extractAlias(buttonElement);
    return product.attributes[attrAlias];
  }

  async getProductVariantId(changedElement, changedAttrValue) {
    const changedAlias = this.extractAlias(changedElement);

    // Convert selected values into a key value collection
    let attributes = {};
    for (const buttonElement of this.elements.variants) {
      let alias = this.extractAlias(buttonElement);
      let value;
      if (alias === changedAlias) {
        value = changedAttrValue;
      } else {
        value = this.getSelectedValue(buttonElement);
      }
      attributes[alias] = value;
    }
    return await this.productService.getProductVariantId(this.config.productId, attributes/*, signal*/);
  }
}
